import React from "react";
import WorkCasePage from "../components/workcase/WorkCasePage";
import imgFerienhaus from "../assets/img/img-work-ferienhaus.png";

function Ferienhaus() {
  return (
    <WorkCasePage
      title="Ferienhaus & Co."
      heroImage={imgFerienhaus}
      heroAlt="Ferienhaus & Co. — UI und API-Anbindung"
    >
      <p>
        Entwicklung des UI, laufende Kundenbetreuung und technische Umsetzung mit
        Anbindung an externe APIs — damit Angebote, Verfügbarkeiten und Buchungslogik
        zuverlässig im Interface ankommen.
      </p>
      <p>
        Schwerpunkt auf verständlichen Buchungsflows, stabilen States (Laden,
        Fehler, Erfolg) und einer Oberfläche, die auf Mobilgeräten genauso funktioniert
        wie am Desktop.
      </p>
    </WorkCasePage>
  );
}

export default Ferienhaus;
